"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = {
  description: 'Create a custom asset, which provides a way to share a component with your organization.',
  flows: [{
    fields: [{
      name: 'mainFile',
      inputType: 'file',
      classifier: 'custom',
      required: false,
      extensions: ['.jpg', '.jpeg', '.png', '.gif', '.svg', '.docx', '.pdf', '.pptx', '.rtf', '.vsdx', '.vssx', '.txt', '.json', '.raml', '.yaml', '.yml', '.md', '.csv', '.xml', '.xsd', '.wsdl', '.html', '.pom', '.log', '.sql', '.zip'],
      hint: 'File should be an image, document, compressed files or text file. See full list [here](https://docs.mulesoft.com/exchange/to-create-an-asset#create-a-custom-asset).'
    }]
  }]
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map